import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CurrenciesService } from '../../../services/currencies.service';
import { Package } from '../../../../models/package';

@Component({
  selector: 'app-select-package',
  templateUrl: './select-package.component.html',
  styleUrls: ['./select-package.component.scss']
})
export class SelectPackageComponent implements OnInit {

  @Input() packages: Package[] = [];
  @Output() packageSelected = new EventEmitter<Package>();
  packageType: number = 0;
  packDesc:string = 'Followers'
  
  symbol:string = "$";
  rate: number = 1;
  constructor( public _currencySer: CurrenciesService) { }

  ngOnInit(): void {
    this._currencySer.currency.subscribe(c=>{
      this.symbol = c.symbol;
      this.rate = c.rate;
    })

    this.packageType = this.packages[0].package_type;

    if(this.packageType === 2){
      this.packDesc = "Likes";
    }
    else if(this.packageType === 3){
      this.packDesc = "Followers";
    }else {
      this.packDesc = "Views";
    }
  }

  setPackageId(pack: Package) {
    this.packageSelected.emit(pack);
  }

}
